import React, { useEffect } from "react";

function Video({ url }: { url: string }) {
  const videoRef = React.createRef<HTMLVideoElement>();

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1.25;
    }
  }, [videoRef]);
  return (
    <video ref={videoRef} controls loop className="w-full h-56">
      <source src={url} type="video/mp4" />
    </video>
  );
}

export default Video;
